import algoliarecommend from "@algolia/recommend";

export default algoliarecommend(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_API_KEY
);
